// Components
import App from './App.vue';
import * as Sentry from '@sentry/vue';
import router from './router';

// Composable
import { createApp } from 'vue';

// Plugins
import { registerPlugins } from '@/plugins';

const app = createApp(App);

Sentry.init({
  app,
  dsn: import.meta.env.VITE_SENTRY_DSN ?? '',
  integrations: [Sentry.browserTracingIntegration({ router })],
  tracesSampleRate: 0.1,
  sampleRate: 0.1,
});

registerPlugins(app);

app.mount('#app');
